export enum DossierItemType {
  Attachment = 0,
  Folder = 1,
  Link = 2,
  Case = 3,
  GoogleDocs = 4,
}
